import AppEvents from 'Shared/app-events';
import ds from 'Shared/ds';

class AccountApi {

    static #onChanged = (result) => AppEvents.emit(this.Events.ACCOUNT_CHANGED, result);

    static settings = () => ds.get(this.#const.SETTINGS);

    static projects = (query) => ds.post(this.#const.PROJECTS, { query });

    static selectProfile = (id, setAsDefault) => ds.post(this.#const.PROFILE_SELECT, { id, setAsDefault })
        .done(this.#onChanged);

    static supplyType = () => ds.get(this.#const.SUPPLYTYPE);

    static selectInvoiceAddress = (id) => ds.post(this.#const.INVOICE_SELECT, { id })
        .done(this.#onChanged);

    static selectShippingAddress = (id) => ds.post(this.#const.SHIPPING_SELECT, { id })
        .done(this.#onChanged);

    static selectSupplyType = (data) => ds.post(this.#const.SUPPLYTYPE, data)
        .done(this.#onChanged);

    static selectProject = (id) => ds.post(this.#const.PROJECT_SELECT, { NVProjectId: id})
        .done(this.#onChanged);

    static selectOnlineStorage = (id) => ds.post(this.#const.ONLINESTORAGE_SELECT, { Id: id })
        .done(this.#onChanged);

    static selectPickupStorage = (id) => ds.post(this.#const.PICKUPSTORAGE_SELECT, { Id: id })
        .done(this.#onChanged);

    Events = this.Events

    static #const = {
        SETTINGS: "/account/settings/data",
        SUPPLYTYPE: "/account/supplytype",
        PROJECTS: "/customer/project/data",
        PROJECT_SELECT: "/account/selectproject",
        PROFILE_SELECT: "/account/selectprofile",
        SHIPPING_SELECT: "/account/shippingaddress",
        INVOICE_SELECT: "/account/invoiceaddress",
        ONLINESTORAGE_SELECT: "/account/onlinestorage",
        PICKUPSTORAGE_SELECT: "/account/pickupstorage"
    };

    static Events = {
        ACCOUNT_CHANGED: "account-changed",
        SHIPPING_SELECT: "account-shipping-select",
        INVOICE_SELECT: "account-invoice-select",
        ACCOUNT_EDIT: "account-edit",
        PASSWORD_SET: "account-setpassword"
    };
}

export default AccountApi;
       

       
